import { service } from '../../../../helpers/http' 

export const ActionGetGroups = ({ dispatch }, payload) => { 
    return service({
        module: 'domainGroup',
        action: 'getGroups',
        payload: payload
    })
}

export const ActionPostGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroup',
        action: 'postGroups',
        payload: payload
    })
    
}

export const ActionPutGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroup',
        action: 'putGroups',
        payload: payload
    })
    
}

export const ActionDeleteGroups = ({ dispatch }, payload) => {

    return service({
        module: 'domainGroup',
        action: 'deleteGroups',
        payload: payload
    })

}

const unwrap = (response) => (response && response.data !== undefined ? response.data : response)

export const ActionGetGroupTrail = (_, payload) => {
    return service({
        module: 'domainGroup',
        action: 'getGroupTrail',
        payload,
        params: {
            id: payload.id,
            page: payload.page,
            per_page: payload.per_page,
        },
    }).then(unwrap)
}

export const ActionLinkGroupTrail = (_, payload) => {
    return service({
        module: 'domainGroup',
        action: 'linkGroupTrail',
        payload,
        params: {
            id: payload.id,
            page: payload.page,
            per_page: payload.per_page,
        },
    }).then(unwrap)
}

export const ActionUnlinkGroupTrail = (_, payload) => {
    return service({
        module: 'domainGroup',
        action: 'unlinkGroupTrail',
        payload,
        params: {
            id: payload.id,
            otherGroupId: payload.otherGroupId,
            page: payload.page,
            per_page: payload.per_page,
        },
    }).then(unwrap)
}
